import { connect } from 'react-redux'

import { getUserPushSettings, saveUserPushSettings } from 'src/modules/Users/actions'
import { getFromSettings } from 'src/utils/helpers'

import Notifications from './Notifications'

const mapDispatchToProps = {
  getUserPushSettings,
  saveUserPushSettings,
}

const mapStateToProps = state => {
  return {
    isGetUserPushSettingsInProgress: state.user.isGetUserPushSettingsInProgress,
    submitGetUserPushSettingsResponse: state.user.submitGetUserPushSettingsResponse,
    getUserPushSettingsPayload: state.user.getUserPushSettingsPayload,
    isSaveUserPushSettingsInProgress: state.user.isSaveUserPushSettingsInProgress,
    submitSaveUserPushSettingsResponse: state.user.submitSaveUserPushSettingsResponse,
    user: state.user.user,
    featureFlags: getFromSettings(state, 'featureFlags', []),
    isWidgetState: state.appReducer.isWidget,
    features: state.appReducer.features,
    labels: getFromSettings(state, 'labels', {}),
    chat: state.appReducer.chat,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)
